export const africanCountries = [
  { Name: "Algeria" },
  { Name: "Angola" },
  { Name: "Benin" },
  { Name: "Botswana" },
  { Name: "Burkina Faso" },
  { Name: "Burundi" },
  { Name: "Cabo Verde" },
  { Name: "Cameroon" },
  { Name: "Central African Republic" },
  { Name: "Chad" },
  { Name: "Comoros" },
  { Name: "Congo" },
  { Name: "Côte d'Ivoire" },
  { Name: "Democratic Republic of the Congo" },
  { Name: "Djibouti" },
  { Name: "Egypt" },
  { Name: "Equatorial Guinea" },
  { Name: "Eritrea" },
  { Name: "Eswatini" },
  { Name: "Ethiopia" },
  { Name: "Gabon" },
  { Name: "Gambia" },
  { Name: "Ghana" },
  { Name: "Guinea" },
  { Name: "Guinea-Bissau" },
  { Name: "Kenya" },
  { Name: "Lesotho" },
  { Name: "Liberia" },
  { Name: "Libya" },
  { Name: "Madagascar" },
  { Name: "Malawi" },
  { Name: "Mali" },
  { Name: "Mauritania" },
  { Name: "Mauritius" },
  { Name: "Morocco" },
  { Name: "Mozambique" },
  { Name: "Namibia" },
  { Name: "Niger" },
  { Name: "Nigeria" },
  { Name: "Rwanda" },
  { Name: "Sao Tome and Principe" },
  { Name: "Senegal" },
  { Name: "Seychelles" },
  { Name: "Sierra Leone" },
  { Name: "Somalia" },
  { Name: "South Africa" },
  { Name: "South Sudan" },
  { Name: "Sudan" },
  { Name: "Tanzania" },
  { Name: "Togo" },
  { Name: "Tunisia" },
  { Name: "Uganda" },
  { Name: "Zambia" },
  { Name: "Zimbabwe" },
];

export const kenyanTowns = [
  // Nairobi County
  "Nairobi",

  // Mombasa County
  "Mombasa",
  "Likoni",
  "Nyali",
  "Bamburi",
  "Diani",

  // Kwale County
  "Ukunda",
  "Shimoni",
  "Msambweni",
  "Lunga Lunga",
  "Kwale",

  // Kilifi County
  "Malindi",
  "Watamu",
  "Kilifi",
  "Takaungu",
  "Mariakani",
  "Vipingo",
  "Mtwapa",

  // Tana River County
  "Hola",
  "Garsen",
  "Galole",

  // Lamu County
  "Lamu",
  "Mpeketoni",
  "Witu",

  // Taita-Taveta County
  "Voi",
  "Taveta",
  "Wundanyi",
  "Mwatate",

  // Garissa County
  "Garissa",
  "Balambala",
  "Hulugho",

  // Wajir County
  "Wajir",
  "Griftu",
  "Buna",
  "Habaswein",

  // Mandera County
  "Mandera",
  "Elwak",
  "Takaba",
  "Rhamu",

  // Marsabit County
  "Marsabit",
  "Moyale",
  "Loiyangalani",

  // Isiolo County
  "Isiolo",
  "Merti",
  "Garba Tula",

  // Meru County
  "Meru",
  "Chuka",
  "Maua",
  "Nkubu",

  // Tharaka-Nithi County
  "Chogoria",
  "Marimanti",

  // Embu County
  "Embu",
  "Runyenjes",
  "Manyatta",

  // Kitui County
  "Kitui",
  "Mwingi",
  "Mutomo",
  "Ikutha",

  // Machakos County
  "Machakos",
  "Athi River",
  "Kangundo",

  // Makueni County
  "Wote",
  "Makindu",
  "Sultan Hamud",

  // Nyandarua County
  "Ol Kalou",
  "Engineer",
  "Nyahururu",

  // Nyeri County
  "Nyeri",
  "Karatina",
  "Othaya",
  "Naromoru",

  // Kirinyaga County
  "Kerugoya",
  "Wanguru",
  "Sagana",

  // Murang'a County
  "Murang'a",
  "Kangema",
  "Maragua",
  "Kandara",

  // Kiambu County
  "Thika",
  "Kiambu",
  "Ruiru",
  "Limuru",
  "Gatundu",
  "Karuri",

  // Turkana County
  "Lodwar",
  "Kakuma",
  "Lokichar",

  // West Pokot County
  "Kapenguria",
  "Makutano",
  "Ortum",

  // Samburu County
  "Maralal",
  "Archers Post",

  // Trans Nzoia County
  "Kitale",
  "Kiminini",

  // Elgeyo-Marakwet County
  "Iten",
  "Kapsowar",

  // Nandi County
  "Kapsabet",
  "Mosoriot",

  // Baringo County
  "Kabarnet",
  "Eldama Ravine",

  // Laikipia County
  "Nanyuki",
  "Rumuruti",

  // Nakuru County
  "Nakuru",
  "Naivasha",
  "Molo",

  // Narok County
  "Narok",
  "Kilgoris",

  // Kajiado County
  "Kajiado",
  "Ngong",
  "Kitengela",
  "Ongata Rongai",

  // Kericho County
  "Kericho",
  "Londiani",

  // Bomet County
  "Bomet",
  "Sotik",

  // Kakamega County
  "Kakamega",
  "Mumias",
  "Malava",
  "Lurambi",

  // Vihiga County
  "Vihiga",
  "Luanda",
  "Mbale",

  // Bungoma County
  "Bungoma",
  "Kimilili",
  "Webuye",
  "Malaba",

  // Siaya County
  "Siaya",
  "Bondo",
  "Ugunja",

  // Kisumu County
  "Kisumu",
  "Ahero",
  // Kisumu County (continued)
  "Maseno",
  "Kibos",

  // Homa Bay County
  "Homa Bay",
  "Kendu Bay",
  "Mbita",

  // Migori County
  "Migori",
  "Awendo",
  "Rongo",

  // Kisii County
  "Kisii",
  "Ogembo",
  "Tabaka",

  // Nyamira County
  "Nyamira",
  "Keroka",

  // Nairobi
  "Nairobi CBD",
  "Westlands",
  "Karen",
  "Parklands",
  "Lang'ata",
  "Kileleshwa",
  "Hurlingham",
  "Runda",
  "Kasarani",
  "Eastleigh",
  "South B",
  "South C",
  "Dagoretti",
  "Embakasi",
  "Madaraka",
  "Roysambu",
  "Gigiri",
  "Lavington",
  "Utawala",
  "Buruburu",
  "Kahawa West",
  "Kahawa Wendani",
  "Imara Daima",
  "Donholm",

  "Mlolongo",
  "Syokimau",
  "Rongai",
  "Thika Road",
  "Mombasa Road",
  "Waiyaki Way",
  "Jogoo Road",
  "Nyeri Road",
  "Thika Town",
];

export const kenyanCounties = [
  {
    name: "Baringo",
    capital: "Kabarnet",
    code: 30,
    sub_counties: [
      "Baringo central",
      "Baringo north",
      "Baringo south",
      "Eldama ravine",
      "Mogotio",
      "Tiaty",
    ],
  },
  {
    name: "Bomet",
    capital: "Bomet",
    code: 36,
    sub_counties: [
      "Bomet central",
      "Bomet east",
      "Chepalungu",
      "Konoin",
      "Sotik",
    ],
  },
  {
    name: "Bungoma",
    capital: "Bungoma",
    code: 39,
    sub_counties: [
      "Bumula",
      "Kabuchai",
      "Kanduyi",
      "Kimilil",
      "Mt Elgon",
      "Sirisia",
      "Tongaren",
      "Webuye east",
      "Webuye west",
    ],
  },
  {
    name: "Busia",
    capital: "Busia",
    code: 40,
    sub_counties: [
      "Budalangi",
      "Butula",
      "Funyula",
      "Nambele",
      "Teso North",
      "Teso South",
    ],
  },
  {
    name: "Elgeyo-Marakwet",
    capital: "Iten",
    code: 28,
    sub_counties: [
      "Keiyo north",
      "Keiyo south",
      "Marakwet east",
      "Marakwet west",
    ],
  },
  {
    name: "Embu",
    capital: "Embu",
    code: 14,
    sub_counties: ["Manyatta", "Mbeere north", "Mbeere south", "Runyenjes"],
  },
  {
    name: "Garissa",
    capital: "Garissa",
    code: 7,
    sub_counties: [
      "Daadab",
      "Fafi",
      "Garissa",
      "Hulugho",
      "Ijara",
      "Lagdera balambala",
    ],
  },
  {
    name: "Homa Bay",
    capital: "Homa Bay",
    code: 43,
    sub_counties: [
      "Homabay town",
      "Kabondo",
      "Karachwonyo",
      "Kasipul",
      "Mbita",
      "Ndhiwa",
      "Rangwe",
      "Suba",
    ],
  },
  {
    name: "Isiolo",
    capital: "Isiolo",
    code: 11,
    sub_counties: [
      "Central",
      "Garba tula",
      "Kina",
      "Merit",
      "Oldonyiro",
      "Sericho",
    ],
  },
  {
    name: "Kajiado",
    code: 34,
    sub_counties: [
      "Isinya.",
      "Kajiado Central.",
      "Kajiado North.",
      "Loitokitok.",
      "Mashuuru.",
    ],
  },
  {
    name: "Kakamega",
    capital: "Kakamega",
    code: 37,
    sub_counties: [
      "Butere",
      "Kakamega central",
      "Kakamega east",
      "Kakamega north",
      "Kakamega south",
      "Khwisero",
      "Lugari",
      "Lukuyani",
      "Lurambi",
      "Matete",
      "Mumias",
      "Mutungu",
      "Navakholo",
    ],
  },
  {
    name: "Kericho",
    capital: "Kericho",
    code: 35,
    sub_counties: [
      "Ainamoi",
      "Belgut",
      "Bureti",
      "Kipkelion east",
      "Kipkelion west",
      "Soin sigowet",
    ],
  },
  {
    name: "Kiambu",
    capital: "Kiambu",
    code: 22,
    sub_counties: [
      "Gatundu north",
      "Gatundu south",
      "Githunguri",
      "Juja",
      "Kabete",
      "Kiambaa",
      "Kiambu",
      "Kikuyu",
      "Limuru",
      "Ruiru",
      "Thika town",
      "lari",
    ],
  },
  {
    name: "Kilifi",
    capital: "Kilifi",
    code: 3,
    sub_counties: [
      "Genzw",
      "Kaloleni",
      "Kilifi north",
      "Kilifi south",
      "Magarini",
      "Malindi",
      "Rabai",
    ],
  },
  {
    name: "Kirinyaga",
    capital: "Kerugoya/Kutus",
    code: 20,
    sub_counties: [
      "Kirinyaga central",
      "Kirinyaga east",
      "Kirinyaga west",
      "Mwea east",
      "Mwea west",
    ],
  },
  {
    name: "Kisii",
    capital: "Kisii",
    code: 45,
    sub_counties: [
      "Kitutu Chache North",
      "Kitutu Chache",
      "Nyaribari Masaba",
      "Nyaribari Chache",
      "Bomachoge Borabu",
      "Bomachoge Chache",
      "Bobasi",
      "South Mugirango",
      "Bonchari",
    ],
  },
  {
    name: "Kisumu",
    capital: "Kisumu",
    code: 42,
    sub_counties: [
      "Kisumu central",
      "Kisumu east ",
      "Kisumu west",
      "Mohoroni",
      "Nyakach",
      "Nyando",
      "Seme",
    ],
  },
  {
    name: "Kitui",
    capital: "Kitui",
    code: 15,
    sub_counties: [
      "Ikutha",
      "Katulani",
      "Kisasi",
      "Kitui central",
      "Kitui west ",
      "Lower yatta",
      "Matiyani",
      "Migwani",
      "Mutitu",
      "Mutomo",
      "Muumonikyusu",
      "Mwingi central",
      "Mwingi east",
      "Nzambani",
      "Tseikuru",
    ],
  },
  {
    name: "Kwale",
    capital: "Kwale",
    code: 2,
    sub_counties: ["Kinango", "Lungalunga", "Msambweni", "Mutuga"],
  },
  {
    name: "Laikipia",
    capital: "Rumuruti",
    code: 31,
    sub_counties: [
      "Laikipia central",
      "Laikipia east",
      "Laikipia north",
      "Laikipia west ",
      "Nyahururu",
    ],
  },
  {
    name: "Lamu",
    capital: "Lamu",
    code: 5,
    sub_counties: ["Lamu East", "Lamu West"],
  },
  {
    name: "Machakos",
    capital: "Machakos",
    code: 16,
    sub_counties: [
      "Kathiani",
      "Machakos town",
      "Masinga",
      "Matungulu",
      "Mavoko",
      "Mwala",
      "Yatta",
    ],
  },
  {
    name: "Makueni",
    capital: "Wote",
    code: 17,
    sub_counties: [
      "Kaiti",
      "Kibwei west",
      "Kibwezi east",
      "Kilome",
      "Makueni",
      "Mbooni",
    ],
  },
  {
    name: "Mandera",
    capital: "Mandera",
    code: 9,
    sub_counties: [
      "Banissa",
      "Lafey",
      "Mandera East",
      "Mandera North",
      "Mandera South",
      "Mandera West",
    ],
  },
  {
    name: "Marsabit",
    capital: "Marsabit",
    code: 10,
    sub_counties: ["Laisamis", "Moyale", "North hor", "Saku"],
  },
  {
    name: "Meru",
    capital: "Meru",
    code: 12,
    sub_counties: [
      "Buuri",
      "Igembe central",
      "Igembe north",
      "Igembe south",
      "Imenti central",
      "Imenti north",
      "Imenti south",
      "Tigania east",
      "Tigania west",
    ],
  },
  {
    name: "Migori",
    capital: "Migori",
    code: 44,
    sub_counties: [
      "Awendo",
      "Kuria east",
      "Kuria west",
      "Mabera",
      "Ntimaru",
      "Rongo",
      "Suna east",
      "Suna west",
      "Uriri",
    ],
  },
  {
    name: "Mombasa",
    capital: "Mombasa City",
    code: 1,
    sub_counties: ["Changamwe", "Jomvu", "Kisauni", "Likoni", "Mvita", "Nyali"],
  },
  {
    name: "Murang'a",
    capital: "Murang'a",
    code: 21,
    sub_counties: [
      "Gatanga",
      "Kahuro",
      "Kandara",
      "Kangema",
      "Kigumo",
      "Kiharu",
      "Mathioya",
      "Murang’a south",
    ],
  },
  {
    name: "Nairobi",
    capital: "Nairobi City",
    code: 47,
    sub_counties: [
      "Dagoretti North Sub County",
      "Dagoretti South Sub County ",
      "Embakasi Central Sub Count",
      "Embakasi East Sub County",
      "Embakasi North Sub County ",
      "Embakasi South Sub County",
      "Embakasi West Sub County",
      "Kamukunji Sub County",
      "Kasarani Sub County ",
      "Kibra Sub County ",
      "Lang'ata Sub County ",
      "Makadara Sub County",
      "Mathare Sub County ",
      "Roysambu Sub County ",
      "Ruaraka Sub County ",
      "Starehe Sub County ",
      "Westlands Sub County ",
    ],
  },
  {
    name: "Nakuru",
    capital: "Nakuru",
    code: 32,
    sub_counties: [
      "Bahati",
      "Gilgil",
      "Kuresoi north",
      "Kuresoi south",
      "Molo",
      "Naivasha",
      "Nakuru town east",
      "Nakuru town west",
      "Njoro",
      "Rongai",
      "Subukia",
    ],
  },
  {
    name: "Nandi",
    capital: "Kapsabet",
    code: 29,
    sub_counties: [
      "Aldai",
      "Chesumei",
      "Emgwen",
      "Mosop",
      "Namdi hills",
      "Tindiret",
    ],
  },
  {
    name: "Narok",
    capital: "Narok",
    code: 33,
    sub_counties: [
      "Narok east",
      "Narok north",
      "Narok south",
      "Narok west",
      "Transmara east",
      "Transmara west",
    ],
  },
  {
    name: "Nyamira",
    capital: "Nyamira",
    code: 46,
    sub_counties: [
      "Borabu",
      "Manga",
      "Masaba north",
      "Nyamira north",
      "Nyamira south",
    ],
  },
  {
    name: "Nyandarua",
    capital: "Ol Kalou",
    code: 18,
    sub_counties: [
      "Kinangop",
      "Kipipiri",
      "Ndaragwa",
      "Ol Kalou",
      "Ol joro orok",
    ],
  },
  {
    name: "Nyeri",
    capital: "Nyeri",
    code: 19,
    sub_counties: [
      "Kieni east",
      "Kieni west",
      "Mathira east",
      "Mathira west",
      "Mkurweni",
      "Nyeri town",
      "Othaya",
      "Tetu",
    ],
  },
  {
    name: "Samburu",
    capital: "Maralal",
    code: 25,
    sub_counties: ["Samburu east", "Samburu north", "Samburu west"],
  },
  {
    name: "Siaya",
    capital: "Siaya",
    code: 41,
    sub_counties: [
      "Alego usonga",
      "Bondo",
      "Gem",
      "Rarieda",
      "Ugenya",
      "Unguja",
    ],
  },
  {
    name: "Taita-Taveta",
    capital: "Voi",
    code: 6,
    sub_counties: ["Mwatate", "Taveta", "Voi", "Wundanyi"],
  },
  {
    name: "Tana River",
    capital: "Hola",
    code: 4,
    sub_counties: ["Bura", "Galole", "Garsen"],
  },
  {
    name: "Tharaka-Nithi",
    capital: "Chuka",
    code: 13,
    sub_counties: [
      "Chuka",
      "Igambangobe",
      "Maara",
      "Muthambi",
      "Tharak north",
      "Tharaka south",
    ],
  },
  {
    name: "Trans-Nzoia",
    capital: "Kitale",
    code: 26,
    sub_counties: ["Cherangany", "Endebess", "Kiminini", "Kwanza", "Saboti"],
  },
  {
    name: "Turkana",
    capital: "Lodwar",
    code: 23,
    sub_counties: [
      "Loima",
      "Turkana central",
      "Turkana east",
      "Turkana north",
      "Turkana south",
    ],
  },
  {
    name: "Uasin Gishu",
    capital: "Eldoret",
    code: 27,
    sub_counties: ["Ainabkoi", "Kapseret", "Kesses", "Moiben", "Soy", "Turbo"],
  },
  {
    name: "Vihiga",
    capital: "Vihiga",
    code: 38,
    sub_counties: ["Emuhaya", "Hamisi", "Luanda", "Sabatia", "vihiga"],
  },
  {
    name: "Wajir",
    capital: "Wajir",
    code: 8,
    sub_counties: [
      "Eldas",
      "Tarbaj",
      "Wajir East",
      "Wajir North",
      "Wajir South",
      "Wajir West",
    ],
  },
  {
    name: "West Pokot",
    capital: "Kapenguria",
    code: 24,
    sub_counties: ["Central Pokot", "North Pokot", "Pokot South", "West Pokot"],
  },
];

export const kenyanSubCounties = [
  // Nairobi County
  "Westlands",
  "Parklands/Highridge",
  "Kilimani",
  "Kasarani",
  "Embakasi",
  "Makadara",
  "Kibra",
  "Langata",
  "Starehe",
  "Dagoretti North",
  "Dagoretti South",
  "Roysambu",
  "Ruaraka",
  "Mathare",
  "Embakasi North",
  "Embakasi South",
  "Embakasi Central",
  "Embakasi East",
  "Embakasi West",
  "Kamukunji",
  "Makongeni",

  // Nakuru County
  "Nakuru East",
  "Nakuru West",
  "Nakuru North",
  "Nakuru South",
  "Nakuru Town East",
  "Nakuru Town West",
  "Kuresoi North",
  "Kuresoi South",
  "Subukia",
  "Rongai",
  "Naivasha",
  "Gilgil",
  "Molo",
  "Njoro",
  "Bahati",

  // Eldoret County
  "Kapseret",
  "Ainabkoi",
  "Kesses",
  "Soy",
  "Turbo",
  "Moiben",
  "Kipkelion West",
  "Kipkelion East",
  "Belgut",
  "Bureti",
  "Sotik",
  "Chepalungu",
  "Bomet East",
  "Bomet Central",
  "Konoin",
  "Nandi Hills",
  "Emgwen",
  "Aldai",
  "Chesumei",
  "Mosop",

  // Machakos County
  "Mwala",
  "Yatta",
  "Kangundo",
  "Matungulu",
  "Kathiani",
  "Masinga",
  "Machakos Town",
  "Mavoko",

  // Nyeri County
  "Tetu",
  "Kieni",
  "Mathira",
  "Othaya",
  "Mukurweini",
  "Nyeri Town",
  "Nyeri South",
  "Mweiga",
  "Mwea",
  "Nyangati",
  "Karatina",
  "Kutus",
  "Nanyuki",
  "Naro Moru",

  // Kisumu County
  "Kisumu East",
  "Kisumu West",
  "Kisumu Central",
  "Seme",
  "Nyando",
  "Muhoroni",
  "Nyakach",
  "Kasipul",
  "Kabondo",
  "Rarieda",
  "Alego Usonga",
  "Gem",

  // Kisii County
  "Bobasi",
  "Bonchari",
  "South Mugirango",
  "Bomachoge Chache",
  "Bomachoge Borabu",
  "Nyaribari Masaba",
  "Nyaribari Chache",
  "Kitutu Chache North",
  "Kitutu Chache South",
  "Kitutu Masaba",

  // Kakamega County
  "Lugari",
  "Likuyani",
  "Malava",
  "Lurambi",
  "Navakholo",
  "Mumias West",
  "Mumias East",
  "Matungu",
  "Butere",
  "Khwisero",
  "Shinyalu",
  "Ikolomani",
  "Vihiga",
  "Sabatia",
  "Hamisi",
  "Luanda",
  "Emuhaya",

  // Garissa County
  "Balambala",
  "Ijara",
  "Lagdera",
  "Dadaab",
  "Fafi",
  "Hulugho",

  // Mandera County
  "Mandera North",
  "Mandera West",
  "Mandera South",
  "Banissa",
  "Mandera East",
  "Lafey",

  // Marsabit County
  "Moyale",
  "North Horr",
  "Saku",
  "Laisamis",
  "Marsabit Central",
  "Marsabit South",

  // Isiolo County
  "Isiolo North",
  "Isiolo South",
  "Garbatulla",
  "Merti",

  // Lamu County
  "Lamu East",
  "Lamu West",
  "Lamu South",

  // Samburu County
  "Samburu East",
  "Samburu West",
  "Samburu Central",
  "Samburu North",
  "Samburu South",

  // Tana River County
  "Bura",
  "Galole",
  "Garsen",

  // Kwale County
  "Matuga",
  "Msambweni",
  "Kinango",
  "Lunga Lunga",

  // Kilifi County
  "Kilifi North",
  "Kilifi South",
  "Kilifi Central",
  "Kaloleni",
  "Rabai",
  "Ganze",
  "Magarini",

  // Mombasa County
  "Changamwe",
  "Jomvu",
  "Kisauni",
  "Nyali",
  "Likoni",
  "Mvita",

  // Taita Taveta County
  "Voi",
  "Wundanyi",
  "Taveta",
  "Mwatate",

  // Makueni County
  "Makueni",
  "Kibwezi",
  "Mbooni",

  // Kitui County
  "Kitui West",
  "Kitui Rural",
  "Kitui Central",
  "Kitui East",
  "Kitui South",
  "Mwingi West",
  "Mwingi Central",
  "Mwingi North",
  "Mwingi East",
  "Mwingi South",

  // Embu County
  "Manyatta",
  "Runyenjes",
  "Mbeere North",
  "Mbeere South",
  "Siakago",
  "Embu West",
  "Embu East",
  "Embu North",
  "Embu South",
  "Embu Town",
];

export const kenyanBanks = [
  "African Banking Corp. Ltd.",
  "Bank of Africa Kenya Ltd.",
  "Bank of India",
  "Bank of Baroda (K) Ltd.",
  "Barclays Bank of Kenya Ltd.",
  "CfC Stanbic Bank Ltd.",
  "Chase Bank (K) Ltd.",
  "Citibank N.A.",
  "Commercial Bank of Africa Ltd.",
  "Consolidated Bank of Kenya Ltd.",
  "Co-operative Bank of Kenya Ltd.",
  "Credit Bank Ltd.",
  "Development Bank (K) Ltd.",
  "Diamond Trust Bank (K) Ltd.",
  "Dubai Bank Ltd.",
  "Ecobank Limited",
  "Equatorial Commercial Bank Ltd.",
  "Equity Bank Ltd.",
  "Family Bank Ltd.",
  "Faulu Bank",
  "Fidelity Commercial Bank Ltd.",
  "Fina Bank Ltd.",
  "First Community Bank Ltd.",
  "Giro Commercial Bank Ltd.",
  "Guardian Bank Ltd.",
  "Gulf African Bank Ltd.",
  "Habib Bank A.G. Zurich",
  "Habib Bank Ltd.",
  "Housing Finance Company of Kenya Ltd.",
  "Imperial Bank Ltd.",
  "I & M Bank Ltd.",
  "Jamii Bora Bank Ltd.",
  "K-Rep Bank Ltd.",
  "Kenya Commercial Bank Ltd.",
  "Kenya Women Microfinance Bank",
  "Middle East Bank (K) Ltd.",
  "National Bank of Kenya Ltd.",
  "NIC Bank Ltd.",
  "NCBA",
  "Oriental Bank Ltd.",
  "Paramount Universal Bank Ltd",
  "Prime Bank Ltd.",
  "Postbank",
  "Standard Chartered Bank (K) Ltd.",
  "Transnational Bank Ltd.",
  "UBA Kenya Bank Ltd.",
  "Victoria Commercial Bank Ltd.",
];
